import { makeVar, InMemoryCache } from "@apollo/client";

// Initialize cart with any stored temporary items
const initializeCart = () => {
  try {
    const tempCartItems = JSON.parse(localStorage.getItem('tempCartItems') || '[]');
    return tempCartItems;
  } catch (error) {
    console.error('Error loading temp cart items:', error);
    return [];
  }
};

export const cartItemsVar = makeVar(initializeCart());
export const serviceCartVar = makeVar([]);
export const favItemsVar = makeVar([]);

export const customInMemoryCache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        cartItems: {
          read() {
            return cartItemsVar();
          },
        },
        serviceCarts: {
          read() {
            return serviceCartVar();
          },
        },
        favItemsVar: {
          read() {
            return favItemsVar();
          },
        },
      },
    },
  },
});
